module.exports = __webpack_public_path__ + "static/media/356.ab1938a6.webp";